import axios from 'axios'
// import router from '@/router' // 根据你的路由路径调整
import { AXIOS_API } from '@/views/storege/index'
import {message} from 'ant-design-vue'
// const message = (value) => {
//     notification.info({
//         message: 'Check for updates automatically',
//         description: value,
//         duration: 10,
//     })
// }

// 创建自定义实例
const axios_service = axios.create({
    // baseURL: AXIOS_API
})

// 请求拦截器
axios_service.interceptors.request.use(
    (config) => {
        // 添加认证 token
        const token = sessionStorage.getItem('Authorization')
        if (token) {
            config.headers.Authorization = `${token}`
        }
        return config
    }
)

// 响应拦截器
axios_service.interceptors.response.use(
    response => {
        // 统一处理业务逻辑
        const response_data = response
        if (response_data.headers['content-type'] != 'application/json'){
            return response_data
        }
        let proper_code = ['200', '201']
        if (proper_code.includes(String(response_data.data.code))) {
            return response_data
        }else{
            message.error(response_data.data.message)
            return response_data
        }
        
    }
)

export default axios_service